import { Avatar, Button } from 'components/ui'
import React from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

function Basket() {
    const navigate = useNavigate()
    const lang = useSelector((state) => state.locale.currentLang)
    const handleBasket = () => {
        navigate(`/${lang}/basket`)
    }
    return (
        <Avatar
            className="cursor-pointer mr-2"
            onClick={handleBasket}
            size={24}
            shape="circle"
            src={`https://cdn.pixabay.com/photo/2015/12/23/01/14/edit-1105049_1280.png`}
        />
    )
    // <Button onClick={handleBasket}>Basket</Button>
}

export default Basket
